<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
        Loading...
      </div>
    </div>
    <div v-if="!loading">
      <div
        class="title-container sort-dropdown"
        :style="{
          display: 'flex',
          justifyContent: 'space-between'
        }"
      >
        <p class="about-title">
          {{
            !aboutCircle.circle[0].condition_type.toLowerCase().includes("my")
              ? " My "
              : ""
          }}{{ aboutCircle.circle[0].condition_type
          }}{{
            !aboutCircle.circle[0].condition_type
              .toLowerCase()
              .includes("circle")
              ? " Circle"
              : ""
          }}
        </p>
        <a-dropdown
          style="margin-top:7px"
          :trigger="['click']"
          :getPopupContainer="trigger => trigger.parentNode"
        >
          <a-icon
            aria-hidden="true"
            type="more"
            :style="{ alignSelf: 'center', padding: '5px', cursor: 'pointer' }"
          />
          <template #overlay>
            <a-menu class="option_menu">
              <a-menu-item
                class="menu_item"
                @click="$router.push({ name: 'LeaveCircle' })"
              >
                <p class="option-item">Leave Circle</p></a-menu-item
              >
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div id="container" class="img-detail-container">
        <img
          v-if="aboutCircle.circle[0].circle_attach.hasOwnProperty('url')"
          class="about-image"
          height="299px"
          width="100%"
          :src="
            aboutCircle.circle[0].circle_attach.hasOwnProperty('url')
              ? aboutCircle.circle[0].circle_attach.resized_images.dov1280x720
              : 'https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/no-image.png'
          "
          alt="about-image"
        />
        <div class="no-img" v-else>
          <img
            src="../../../assets/icons/no-image.svg"
            width="20px"
            height="18px"
            alt="defualtImage"
          />
        </div>
        <div class="details-wrapper">
          <div class="detail-container">
            <p class="detail-subtitle">Members</p>
            <p class="detail-info">{{ aboutCircle.circle[0].no_of_members }}</p>
          </div>
          <div class="detail-container">
            <p class="detail-subtitle">Posts</p>
            <p class="detail-info">{{ aboutCircle.circle[0].no_of_post }}</p>
          </div>
          <div class="detail-container">
            <p class="detail-subtitle">Replies</p>
            <p class="detail-info">{{ aboutCircle.circle[0].comment_count }}</p>
          </div>
        </div>
      </div>
      <div style="display:flex;">
        <button
          @click="isAbout = 0"
          class="button"
          v-bind:style="[
            isAbout === 0
              ? { background: getPrimary50Color(), color: getPrimaryColor() }
              : { background: 'white', color: '#0f1734' }
          ]"
        >
          About
        </button>
        <button
          @click="fetchMedia"
          class="button"
          v-bind:style="[
            isAbout === 1
              ? { background: getPrimary50Color(), color: getPrimaryColor() }
              : { background: 'white', color: '#0f1734' }
          ]"
        >
          Media
        </button>
        <button
          v-if="aboutCircle.is_moderator"
          @click="isAbout = 2"
          class="button"
          v-bind:style="[
            isAbout === 2
              ? { background: getPrimary50Color(), color: getPrimaryColor() }
              : { background: 'white', color: '#0f1734' }
          ]"
        >
          Reports
        </button>
      </div>
      <div v-if="isAbout === 0">
        <p class="about-info pb-0 mb-0">
          {{ aboutCircle.circle[0].description }}
        </p>
        <p class="about-info">
          {{ aboutCircle.circle[0].long_description }}
        </p>
        <p
          v-if="doveMedStats.hasOwnProperty('physicians')"
          class="ecosystem-title"
        >
          DoveMed ecosystem has
        </p>
        <div
          v-if="doveMedStats.hasOwnProperty('physicians')"
          :style="{ display: 'flex', gap: '24px', flexWrap: 'wrap' }"
        >
          <div :style="{ display: 'flex' }">
            <img
              src="../../../assets/userdoctor.svg"
              style="transform: scale(0.7); width: 24px"
              alt="physician"
            />
            <p class="ecosystem-item">
              {{ formatNum(doveMedStats.physicians || 0) }} Physicians
            </p>
          </div>
          <div :style="{ display: 'flex' }">
            <img
              src="../../../assets/hospitalwide.svg"
              style="transform: scale(0.8); width: 24px"
              alt="hospital"
            />
            <p class="ecosystem-item">
              {{ formatNum(doveMedStats.hospitals || 0) }} Hospitals
            </p>
          </div>
          <div :style="{ display: 'flex' }">
            <img
              src="../../../assets/hospital.svg"
              style="transform: scale(0.5); width: 24px;"
              alt="clinic"
            />
            <p class="ecosystem-item">
              {{ formatNum(doveMedStats.clinics || 0) }} Clinics
            </p>
          </div>
          <div :style="{ display: 'flex' }">
            <font-awesome-icon
              size="2x"
              style="transform: scale(0.7); width: 24px"
              :icon="['fal', 'hand-holding-heart']"
            />
            <p class="ecosystem-item">
              {{ formatNum(doveMedStats.nfps || 0) }} Non-For-Profits
            </p>
          </div>
          <div :style="{ display: 'flex' }">
            <font-awesome-icon
              size="2x"
              style="transform: scale(0.7); width: 24px"
              :icon="['fal', 'user-nurse']"
            />
            <p class="ecosystem-item">
              {{ formatNum(doveMedStats.ohcps || 0) }} Advanced Medical
              Professionals
            </p>
          </div>
        </div>
        <p class="ecosystem-title marginClass">
          Your contribution to My
          {{
            aboutCircle.circle[0].condition_type
              .replace("My", "")
              .replace("Circle", "")
              .replace("my", "")
              .replace("circle", "")
              .trim()
          }}
          circle
        </p>
        <div class="contribution-wrapper">
          <div class="detail-container">
            <p class="detail-subtitle">Posts</p>
            <p class="detail-info">{{ aboutCircle.user_post_count }}</p>
          </div>
          <div class="detail-container">
            <p class="detail-subtitle">Comments</p>
            <p class="detail-info">{{ aboutCircle.user_comment_count }}</p>
          </div>
          <div class="detail-container">
            <p class="detail-subtitle">Reactions</p>
            <p class="detail-info">{{ aboutCircle.user_reactions_count }}</p>
          </div>
          <div class="detail-container">
            <p class="detail-subtitle">Reviews given</p>
            <p class="detail-info">{{ aboutCircle.total_review_count }}</p>
          </div>
        </div>
      </div>
      <div v-if="mediaLoading" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
      <div
        v-if="isAbout === 1 && mediaImages === null && !mediaLoading"
        style="display: flex; justify-content:center; padding: 24px;"
      >
        No Media
      </div>
      <div v-if="isAbout === 1" class="media-container">
        <div
          v-if="mediaImages != null && mediaImages.length > 0 && !mediaLoading"
          v-for="(image, imageIndex) in mediaImages"
          :key="imageIndex"
          style="position: relative;"
        >
          <img
            v-if="image.type.includes('image')"
            class="media-image"
            :src="image.resized_images.dov640x320"
            alt="media-image"
            @click="$refs.imageModal.showModal(mediaImages, imageIndex)"
          />
          <video
            v-if="image.type.includes('video')"
            class="media-image"
            :src="image.url"
            @click="$refs.imageModal.showModal(mediaImages, imageIndex)"
          />
          <div
            v-if="image.type.includes('video')"
            @click="$refs.imageModal.showModal(mediaImages, imageIndex)"
            class="media-image skeleton"
          >
            <div class="play_button">
              <font-awesome-icon
                size="2x"
                class="play_icon"
                :icon="['fas', 'play']"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          isAbout === 1 &&
            mediaImages != null &&
            mediaImages.length > 0 &&
            !mediaLoading
        "
        :style="{
          padding: '30px',
          display: 'flex',
          justifyContent: 'center'
        }"
      >
        <a-pagination
          v-model="page"
          class="dovemed-custom-pagination"
          :total="total_count"
          show-less-items
          :pageSize="10"
          @change="fetchMedia"
        />
      </div>
      <ImageFullScreenModal ref="imageModal" />
      <Reports v-if="isAbout === 2" :scroll="$el.querySelector('#container')" />
    </div>
  </div>
</template>

<script>
import ImageFullScreenModal from "../../Modals/ImageFullScreenModal";
import Reports from "./Reports.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

library.add(faPlay);

const AboutCircleRepository = RepositoryFactory.get("aboutCircle");

export default {
  name: "AboutCircle",

  components: {
    ImageFullScreenModal,
    Reports
  },

  data() {
    return {
      aboutCircle: null,
      loading: true,
      mediaLoading: false,
      doveMedStats: {},
      isAbout: 0,
      mediaImages: null,
      page: 1,
      items: 10,
      total_count: 0
    };
  },
  mounted() {
    this.fetchAboutCircle();
    this.fetchDoveMedStats();
  },
  methods: {
    formatNum(num) {
      return Intl.NumberFormat("en", { notation: "compact" }).format(num);
    },
    fetchAboutCircle() {
      this.loading = true;
      AboutCircleRepository.getAboutCircle(
        this.currentCircle.id,
        this.authUser.user.id
      )
        .then(res => {
          this.aboutCircle = res.data.data;
          // this.mediaImages = res.data.data.url;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    fetchDoveMedStats() {
      AboutCircleRepository.getDoveMedStats()
        .then(res => {
          this.doveMedStats = res.data;
        })
        .catch(err => {});
    },
    fetchMedia() {
      this.mediaLoading = true;
      if (this.isAbout === 1) {
        var el = this.$el.querySelector("#container");
        el.scrollIntoView();
      }
      this.isAbout = 1;
      AboutCircleRepository.getMedia(
        this.currentCircle.id,
        this.page,
        this.items
      )
        .then(res => {
          if (res.data.data.length > 0) {
            let imageList = [];
            this.mediaImages = res.data.data;
            this.mediaImages.forEach(imgArray => {
              if (Array.isArray(imgArray.image_attach_url)) {
                imgArray.image_attach_url.forEach(img => {
                  if (!img.hasOwnProperty("sensitive")) {
                    img["sensitive"] = false;
                  }
                  if (!img.hasOwnProperty("type")) {
                    img["type"] = img.url.includes("mp4") ? "video" : "image";
                  }
                });
              } else {
                imgArray.image_attach_url = [
                  {
                    type: "image",
                    sensitive: false,
                    url:
                      "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/no-image.png"
                  }
                ];
              }
            });
            this.mediaImages.map(item => {
              item.image_attach_url.map(img => {
                console.log(img.url);
                imageList.push(img);
              });
            });
            this.mediaImages = imageList;
            this.total_count = res.data.paginator.total_count;
          }
          this.mediaLoading = false;
        })
        .catch(err => {
          this.mediaLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.title-container {
  @media only screen and (max-width: 700px) {
    margin-top: 24px;
  }
}
.about-title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-bottom: 0px;
}

.option-item {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #1e2945;
  padding: 5px 10px;
  padding-right: 20px;
  margin: 0px;
}
.menu_item {
  padding: 5px 10px;
}
.menu_item:hover {
  background: #fafafa;
  border-radius: 5px;
}
.option_menu {
  padding: 0px;
  border-radius: 8px;
  position: sticky;
}

.about-image {
  max-width: 584px;
  min-width: 100px;
  height: 299px;
  border-radius: 8px;
  object-fit: cover;
  @media only screen and (min-width: 701px) {
    margin-right: 24px;
  }
  @media only screen and (max-width: 700px) {
    margin-bottom: 24px;
  }
  flex: 1;
}
.no-img {
  max-width: 584px;
  min-width: 100px;
  height: 299px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e2e8f0;
  @media only screen and (min-width: 701px) {
    margin-right: 24px;
    flex: 1;
  }
  @media only screen and (max-width: 700px) {
    margin-bottom: 24px;
  }
}
.media-container {
  display: grid;
  grid-template-columns: auto auto;
  @media only screen and (max-width: 500px) {
    grid-template-columns: auto;
  }
  gap: 24px;
  margin: 72px 0px;
}

.media-image {
  max-width: 383px;
  @media only screen and (max-width: 500px) {
    max-width: 500px;
  }
  width: 100%;
  height: 218px;
  object-fit: cover;
  cursor: pointer;
}

.skeleton {
  position: absolute;
  background: transparent;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .play_button {
    width: 60px;
    height: 60px;
    background-color: #3b3b3b;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .play_icon {
    width: 30px;
    height: 30px;
    color: white;
    margin-left: 5px;
  }
}

@media only screen and (min-width: 1230px) {
  .media-image {
    width: 383px;
  }
}

.details-wrapper {
  @media only screen and (max-width: 700px) {
    display: flex;
    gap: 13px;
  }
}
.detail-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0px;
  width: 182.5px;
  @media only screen and (max-width: 700px) {
    max-width: 300px;
    width: 100%;
  }
  height: 70px;
  background: #f1f5f9;
  margin-bottom: 13px;
}

.img-detail-container {
  display: flex;
  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
  justify-content: space-between;
  padding: 24px 0px;
}

.detail-subtitle {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
  margin-bottom: 0px;
}

.detail-info {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #0f1734;
  margin-bottom: 0px;
}

.button {
  border-radius: 6px;
  border: none;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  font-weight: 700;
  padding: 12px 24px;
}

.button-text {
  padding: 12px 24px;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  margin: 0px;
  font-weight: 700;
}

.about-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
  padding: 24px 0px;
}

.ecosystem-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #0f1734;
  margin-bottom: 24px;
}

.marginClass {
  margin-top: 104px;
  @media only screen and (max-width: 700px) {
    margin-top: 48px;
  }
}
.contribution-wrapper {
  display: flex;
  gap: 13px;
  flex-wrap: wrap;
  @media only screen and (max-width: 700px) {
    display: grid;
    grid-template-columns: auto auto;
  }
}

.ecosystem-item {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #0f1734;
  text-align: center;
  align-self: center;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/aboutCircle/AboutCircle.vue